import yup from '../yup-extended';
import { Address } from '@cobra/interfaces-enums-mocks/interfaces';

export const addressShape = {
    street: yup.string().nullable().trim().label('Straße').max(100),
    houseNumber: yup.string().nullable().trim().label('Hausnr.').max(25),
    zip: yup.string().nullable().trim().label('PLZ').zip({ excludeEmptyString: true }),
    city: yup.string().nullable().trim().label('Ort').max(75),
};
export const addressSchema: yup.SchemaOf<Omit<Address, 'areaCode'>> = yup.object(addressShape);
export const streetSchema = addressShape.street;
export const houseNumberSchema = addressShape.houseNumber;
export const zipSchema = addressShape.zip;
export const citySchema = addressShape.city;
